import { ref } from 'vue'

import type { DropdownOption } from '@/components/common/ui/inputs/inputTypes'

import { useFrappeNestCustomAPIStore } from '@/stores/apis/frappeNestCustomAPI'

const useBankOptions = (): {
  bankOptions: typeof bankOptions
  isLoadingBankOptions: typeof isLoadingBankOptions
  loadBankOptions(currentValue?: string): Promise<void>
} => {
  const bankOptions = ref<DropdownOption<string>[]>([])
  const isLoadingBankOptions = ref(false)
  const customAPIStore = useFrappeNestCustomAPIStore()

  const loadBankOptions = async (currentValue?: string): Promise<void> => {
    if (isLoadingBankOptions.value) {
      return
    }

    isLoadingBankOptions.value = true
    try {
      const banks = await customAPIStore.getBankList(['name', 'bank_name'])
      const mapped: DropdownOption<string>[] = banks.map((bank) => {
        return {
          optionLabel: bank.bank_name ?? bank.name ?? '',
          optionValue: bank.name ?? '',
        }
      })

      const hasCurrent =
        !!currentValue &&
        mapped.some((option) => {
          return option.optionValue === currentValue
        })

      bankOptions.value =
        hasCurrent || !currentValue
          ? mapped
          : mapped.concat({
              optionLabel: currentValue,
              optionValue: currentValue,
            })
    } catch (errorMsg) {
      console.error('getBankList error', errorMsg)
      bankOptions.value = []
    } finally {
      // eslint-disable-next-line require-atomic-updates
      isLoadingBankOptions.value = false
    }
  }

  return {
    bankOptions,
    isLoadingBankOptions,
    loadBankOptions,
  }
}

export { useBankOptions }
